module.exports = __webpack_public_path__ + "img/mail.cd4b296b.svg";